import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_djj9pae5kc: FaireBrandEntity = {
  token: "b_djj9pae5kc",
  type: "brand",
  name: "LA Herb",
  avatarUrl:
    "https://cdn.faire.com/fastly/c49b43009e718fc42c4bb1f79180499460277690866adc1557e7dd8504002835.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/28f8130386e177e3ba9c08aba7a1b233ec243330a51ce4d9a40e0fd4aa07632c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c49b43009e718fc42c4bb1f79180499460277690866adc1557e7dd8504002835.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/28f8130386e177e3ba9c08aba7a1b233ec243330a51ce4d9a40e0fd4aa07632c.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 38,
  isTopShop: true,
  isInsider: true,
  description:
    "Los Angeles Herb based in Los Angeles, California, is the top source for small and bulk herbs, teas, roots, botanicals and more. LA Herb specializes in exotic and wildcrafted herbs. We offer top quality products at an affordable price.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:37.955Z",
    importedBy: "entity-db-cli",
  },
};
